import gql from "graphql-tag";
const createGenoplotsamples = gql(`mutation CreateGenoplotsamples($input: CreateGenoplotsamplesInput!) {
  createGenoplotsamples(input: $input) {
    group
    sample
    age
    SSE
    description
    coords
    coords2
    ethnicity
    download
    bucket
    object
    created
    vendor
    storage
    origin
    owner
    public
    entityType
    type
  }
}
`);
const updateGenoplotsamples = gql(`mutation UpdateGenoplotsamples($input: UpdateGenoplotsamplesInput!) {
  updateGenoplotsamples(input: $input) {
    group
    sample
    age
    SSE
    description
    coords
    coords2
    ethnicity
    bucket
    vendor
    download
    created
    object
    storage
    origin
    owner
    public
    entityType
    type
  }
}
`);
const deleteGenoplotsamples = gql(`mutation DeleteGenoplotsamples($input: DeleteGenoplotsamplesInput!) {
  deleteGenoplotsamples(input: $input) {
    group
    sample
  }
}
`);
const modifySamplesMutations = {
    delete: deleteGenoplotsamples,
    insert: createGenoplotsamples,
    update: updateGenoplotsamples
}
export default modifySamplesMutations;
